export default __webpack_public_path__ + "12ebca3877f645a6d0118ce6817b35b0.jpg";